<template>
  <v-app-bar
    height="132"
    app
    class="navigation-admin"
  >
    <div class="upper__wrapper">
      <router-link
        :to="{ name: 'tyre' }"
        class="logo"
        rel="nofollow"
      >
        <img :src="require('@/assets/images/erm_logo_new.png')">
      </router-link>
      <navigation-search-bar />
      <div class="info__wrapper">
        <v-btn
          icon
          plain
          class="info__icon"
          @click="$refs.searchInfoRef.show()"
        >
          <icon-info
            color="var(--theme-primary)"
            size="50"
          />
        </v-btn>
        <span>{{ $t('langkey.explanation-info-button') }}</span>
      </div>
      <router-link
        v-if="userType === 'TEST USER'"
        class="link__register-full"
        :to="{ name: 'register-full' }"
        rel="nofollow"
        v-html="`${$t('langkey.register_full_text')}`"
      />
      <v-spacer />
      <div class="opt-in__wrapper">
        <opt-in-field />
      </div>
      <v-btn
        icon
        plain
        class="dealer-calculation-info__icon"
        @click="$refs.dealerCalculationDialog.show()"
      >
        <icon-info color="var(--theme-primary)" />
      </v-btn>
      <div class="right">
        <div class="divider" />
        <currency-dropdown
          :is-disable-selection="isOptIn"
        />
        <v-btn
          plain
          @click="openSupportModal"
        >
          {{ $t(navbar.support.title) }}
        </v-btn>
        <base-dialog
          ref="simpleDialog"
          :title="navbar.support.title"
        >
          <!-- <h1>{{ $t() }}</h1> -->
          <br>
          <p v-html="$t(navbar.support.content)" />
        </base-dialog>
        <base-dropdown
          :item="navbar.user"
          :is-show-text="isShowText"
          :is-opt-in="isOptIn"
          @logout="logout"
        >
          <template #content(user)>
            <v-list-item-avatar
              size="24"
              tile
            >
              <icon-user />
            </v-list-item-avatar>
            <v-list-item-title>
              {{ getUsername }}
            </v-list-item-title>
          </template>
          <template #content(settings)="{ data }">
            <v-list-item-avatar
              size="24"
              tile
            >
              <icon-admin-area :is-active="data.isActive" />
            </v-list-item-avatar>
            <v-list-item-title>
              {{ $t(data.title) }}
            </v-list-item-title>
          </template>
          <template #content(shop)="{ data }">
            <v-list-item-avatar
              size="24"
              tile
            >
              <icon-cart
                outlined
                :is-active="data.isActive"
              />
            </v-list-item-avatar>
            <v-list-item-title>
              {{ $t(data.title) }}
            </v-list-item-title>
          </template>
          <template #content(adminArea)="{ data }">
            icon
            <v-list-item-title>
              {{ $t(data.title) }}
            </v-list-item-title>
          </template>
          <template #content(logout)="{ data }">
            <v-list-item-avatar
              size="24"
              tile
            >
              <icon-logout />
            </v-list-item-avatar>
            <v-list-item-title>
              {{ $t(data.title) }}
            </v-list-item-title>
          </template>
        </base-dropdown>
        <v-btn
          icon
          plain
          class="cart__icon"
          :to="{ name: 'cart' }"
        >
          <icon-cart :is-opt-in="isOptIn" />
        </v-btn>
      </div>
    </div>
    <div class="sub__navbar custom-container">
      <div class="nav__items">
        <router-link
          v-for="(item, index) in adminMenu"
          :key="`${item}${index}`"
          :to="{ name: item.to }"
          class="nav__item"
          rel="nofollow"
        >
          {{ $t(item.label) }}
        </router-link>
        <router-link
          v-if="isAllowAddressUser"
          :to="{ name: 'admin-delivery-address' }"
          class="nav__item"
          rel="nofollow"
        >
          {{ $t('langkey.extend_delivery_address') }}
        </router-link>
        <router-link
          :to="{ name: 'admin-bank' }"
          class="nav__item"
          rel="nofollow"
        >
          {{ $t('langkey.bank-sepa') }}
        </router-link>
      </div>
      <info-dialog ref="searchInfoRef" />
    </div>

    <base-dialog ref="dealerCalculationDialog">
      <div class="dealer-calculation-dialog__content">
        <span v-html="$t('langkey.modal-dealer-calculation-dialog')" />
      </div>
    </base-dialog>
  </v-app-bar>
</template>

<style lang="scss">
@import '@/styles/components/navigation-admin.scss';
</style>

<script>
import IconInfo from '@/components/icons/IconInfo';
import IconAdminArea from '@/components/icons/IconAdminArea';
import IconCart from '@/components/icons/IconCart';
import IconUser from '@/components/icons/IconUser';
import IconLogout from '@/components/icons/IconLogout';
import InfoDialog from '@/components/InfoDialog';
import CurrencyDropdown from '@/components/CurrencyDropdown';
import OptInField from '@/components/OptInField';
import NavigationSearchBar from '@/components/NavigationSearchBar';

import { adminMenu } from '@/configs/components/adminMenu.js';
import { removeCookie } from '@/utils/js-cookie';
import { mapState } from 'vuex';
import { tyreCarVehicleTypesGroup, tyreAllAvailableVehicleTypes } from '@/constants/tyreMenuGroup';

export default {
  components: {
    IconInfo,
    IconAdminArea,
    IconCart,
    IconUser,
    IconLogout,
    InfoDialog,
    CurrencyDropdown,
    OptInField,
    NavigationSearchBar,
  },
  data() {
    return {
      isShowText: false,
      navbar: {
        support: {
          title: 'langkey.support',
          content: 'langkey.support-content',
        },
        marketplace: {
          title: '',
          icon: 'Marketplace',
          items: [
            { title: 'Offering', to: 'marketplace-offering' },
            { title: 'Offer', to: 'marketplace-offer' },
            { title: 'Sale', to: 'marketplace-sale' },
          ],
          inactive: true,
        },
        user: {
          title: '',
          icon: 'User',
          items: [
            { key: 'user', customContent: true },
            { key: 'settings', title: 'langkey.settings', customContent: true, to: 'admin-overview' },
            { key: 'shop', title: 'langkey.shop', customContent: true, to: 'tyre' },
            { key: 'logout', title: 'langkey.logout', customEvent: 'logout', customContent: true },
          ],
        },
      },
      logoutButton: {
        title: 'Logout',
      },
    };
  },
  computed: {
    ...mapState('user', {
      userType: 'userType',
      userInformation: 'userInformation',
      isAllowAddressUser: 'isAllowAddressUser',
    }),
    ...mapState('pricing', {
      isOptIn: 'isOptIn',
    }),
    adminMenu() {
      return adminMenu;
    },
    getUsername() {
      if (this.userInformation) {
        return this.userInformation.username;
      } else {
        return '';
      }
    },
  },
  methods: {
    logout() {
      removeCookie('user_access_token');
      sessionStorage.removeItem('userInformation');
      sessionStorage.removeItem('userType');
      sessionStorage.removeItem('customerInformation');
      sessionStorage.removeItem('mailpwpopupopen');
      sessionStorage.removeItem('showInfoDialog');
      this.$router.replace(
        this.$i18nRoute({
          name: 'login',
        }),
      );
    },
    openSupportModal() {
      this.$refs.simpleDialog.show();
    },
  },
};
</script>
